let paConfig = {
  "configuration": {
    "_site": 632734,
    "site": 596277,
    "collectDomain": "https://logs1413.xiti.com"
  },
  "params": {
    "site": "BR",
    "site_level2": "Bayern 1",
    "page": "special",
    "page_chapter1": "Quiz",
    "page_chapter2": "",
    "page_chapter3": "",
    "bereich": "Radio", //  x1
    "welle_angebot": "Bayern 1",  //  x2
    "rubrik": "Specials", //  x4
    "sendereihe": "keine Sendereihe", //  x5
    "inhaltstyp": "Quiz", //  x6
    "seitenname_id": "",  //  x7
    "seitentitel": "BAYERN 1 Quiz", //  x8
    "tag_schlagworter": "", //  x9
    "datum": 20220301,
    "url": "",  //  x11
    "board_id": "", //  x12
    "vorherige_seite": "",  //  x13
    "ausliefernde_plattform": "Web",  //  x14
    "dachzeile": "BAYERN 1 - Quiz", //  x15
    "content_description": "",
  }
}

export {
  paConfig
}
